export function getMilestone() {
  return null;
}

export default {
  getMilestone,
};
